import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { MedecinComponent } from './medecin/medecin.component';
import { QuestonaireComponent } from './questonaire/questonaire.component';
import { MesHistoriqueComponent } from './mes-historique/mes-historique.component';
import { AjoutDocteurComponent, NgbdModalContent_I } from './modal/ajout-docteur/ajout-docteur.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { RemboursementComponent } from './remboursement/remboursement.component';
import { AnalyseComponent } from './analyse/analyse.component';
import { ConsulatationMedicaleComponent } from './consulatation-medicale/consulatation-medicale.component';
import { IecComponent } from './information/iec/iec.component';
import { TextComponent } from './information/text/text.component';
import { ContactComponent } from './information/contact/contact.component';
import { HttpClientModule } from "@angular/common/http";
import { EvaluationEnligneComponent } from './evaluation-enligne/evaluation-enligne.component';
import { PopupModule } from 'ng2-opd-popup';
//import { ChartsModule } from 'ng2-charts';
import { MedecinAnsComponent } from './medecin-ans/medecin-ans.component';
import { MedecinTszComponent } from './medecin-tsz/medecin-tsz.component';
import { AjoutDocteurTszComponent, NgbdModalContent } from './modal/ajout-docteur-tsz/ajout-docteur-tsz.component';
//import { InfrastructureComponent } from './infrastructure/infrastructure.component';
//import { ActualiterComponent } from './actualiter/actualiter.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
//import { FullCalendarModule } from '@fullcalendar/angular'

import {MatPaginatorModule } from '@angular/material';
import { InfoAnalyseComponent } from './info-analyse/info-analyse.component';
import { ProcedureConsultationComponent } from './consulatation-medicale/procedure-consultation/procedure-consultation.component';
import { AffichageConsultationComponent } from './consulatation-medicale/affichage-consultation/affichage-consultation.component';
import { StatistiqueConsultationComponent } from './consulatation-medicale/statistique-consultation/statistique-consultation.component';
import { StatistiqueRembourseComponent } from './remboursement/statistique-rembourse/statistique-rembourse.component';
import { InfoRembourseComponent } from './remboursement/info-rembourse/info-rembourse.component';
import { ProcedureRembourseComponent } from './remboursement/procedure-rembourse/procedure-rembourse.component';
import { DetailIecComponent } from './information/detail-iec/detail-iec.component';
import { CalendrierMedecinComponent } from './consulatation-medicale/calendrier-medecin/calendrier-medecin.component';
import { RapportActiviteComponent } from './rapport-activite/rapport-activite.component';
import { NosInfrastructureComponent } from './nos-infrastructure/nos-infrastructure.component';
import { NgbdModalComponent } from '../components/modal/modal.component';
import { SatistiqueConsultationMedComponent } from './consulatation-medicale/satistique-consultation-med/satistique-consultation-med.component';
import { SatistiqueConsultationAgentComponent } from './consulatation-medicale/satistique-consultation-agent/satistique-consultation-agent.component';
import { StatistiqueRembourseAgentComponent } from './remboursement/statistique-rembourse-agent/statistique-rembourse-agent.component';
import { StatistiqueRembourseTraiteComponent } from './remboursement/statistique-rembourse-traite/statistique-rembourse-traite.component';
import { StatistiqueGlobalComponent } from './statistique-global/statistique-global.component';
import { StatistiqueGlobalConsultationComponent } from './statistique-global/statistique-global-consultation/statistique-global-consultation.component';
import { StatistiqueGlobalRemboursementComponent } from './statistique-global/statistique-global-remboursement/statistique-global-remboursement.component';
import { StatistiqueGlobalReposMedicaleComponent } from './statistique-global/statistique-global-repos-medicale/statistique-global-repos-medicale.component';
import { StatistiqueGlobalAgentEtFamilleComponent } from './statistique-global/statistique-global-agent-et-famille/statistique-global-agent-et-famille.component';
import { BibliothequeVirtuelleComponent } from './bibliotheque-virtuelle/bibliotheque-virtuelle.component';
import { StatistiqueReposAgentComponent } from './consulatation-medicale/statistique-repos-agent/statistique-repos-agent.component';
import { GestionMedicamentComponent } from './gestion-medicament/gestion-medicament.component';
import { GestionMedicamentPharmacieComponent } from './gestion-medicament/gestion-medicament-pharmacie/gestion-medicament-pharmacie.component';
import { GestionMedicamentEntrepotComponent } from './gestion-medicament/gestion-medicament-entrepot/gestion-medicament-entrepot.component';
import { MedicamentConsommerParAgentComponent } from './gestion-medicament/medicament-consommer-par-agent/medicament-consommer-par-agent.component';
import { MedicamentLivrerComponent } from './gestion-medicament/medicament-livrer/medicament-livrer.component';
import { VideoDrOnjaComponent, NgbdModalContent_o } from './modal/ajout-docteur/video-dr-onja/video-dr-onja.component';
import { VideoDrRinaComponent, NgbdModalContent_r } from './modal/ajout-docteur/video-dr-rina/video-dr-rina.component';
import { VideoDrVonyComponent, NgbdModalContent_v } from './modal/ajout-docteur/video-dr-vony/video-dr-vony.component';
import { VideoDrNorolalaComponent, NgbdModalContent_no } from './modal/ajout-docteur/video-dr-norolala/video-dr-norolala.component';
import { VideoDrRolandComponent, NgbdModalContent_ro } from './modal/ajout-docteur/video-dr-roland/video-dr-roland.component';
import { VideoDrLaingoComponent, NgbdModalContent_laing } from './modal/ajout-docteur-tsz/video-dr-laingo/video-dr-laingo.component';
import { VideoDrFanjaComponent, NgbdModalContent_fan } from './modal/ajout-docteur-tsz/video-dr-fanja/video-dr-fanja.component';
import { VideoDrNivoComponent, NgbdModalContent_niv } from './modal/ajout-docteur-tsz/video-dr-nivo/video-dr-nivo.component';
import { VideoDrKoloinaComponent, NgbdModalContent_kol } from './modal/ajout-docteur-tsz/video-dr-koloina/video-dr-koloina.component';
import { VideoDrThieryComponent, NgbdModalContent_thier } from './modal/ajout-docteur-tsz/video-dr-thiery/video-dr-thiery.component';
import { VideoDrHeryComponent, NgbdModalContent_her } from './modal/ajout-docteur-tsz/video-dr-hery/video-dr-hery.component';
import { VideoDrHaryComponent, NgbdModalContent_har } from './modal/ajout-docteur-tsz/video-dr-hary/video-dr-hary.component';
import { VideoDrRijaMamyComponent, NgbdModalContent_ri_ma } from './modal/ajout-docteur-tsz/video-dr-rija-mamy/video-dr-rija-mamy.component';
import { VideoDrManohyComponent, NgbdModalContent_man } from './modal/ajout-docteur-tsz/video-dr-manohy/video-dr-manohy.component';
import { VideoDrAndryComponent, NgbdModalContent_andr } from './modal/ajout-docteur-tsz/video-dr-andry/video-dr-andry.component';
import { VideoDrIfanoComponent, NgbdModalContent_ifan } from './modal/ajout-docteur-tsz/video-dr-ifano/video-dr-ifano.component';
import { ViewMedicamentLivrerComponent } from './gestion-medicament/medicament-livrer/view-medicament-livrer/view-medicament-livrer.component';
import { LienUtileComponent } from './lien-utile/lien-utile.component';
import { MedParPharmacieComponent } from './gestion-medicament/gestion-medicament-pharmacie/med-par-pharmacie/med-par-pharmacie.component';
import { VideDrTianaComponent, NgbdModalContent_tia } from './modal/ajout-docteur-tsz/vide-dr-tiana/vide-dr-tiana.component';
import { VideDrLantoComponent, NgbdModalContent_la } from './modal/ajout-docteur-tsz/vide-dr-lanto/vide-dr-lanto.component';
import { VoireQuestionComponent } from './questonaire/voire-question/voire-question.component';
import { RapportActiviterRembourseComponent } from './rapport-activite/rapport-activiter-rembourse/rapport-activiter-rembourse.component';
import { RapportActiviterMedecinComponent } from './rapport-activite/rapport-activiter-medecin/rapport-activiter-medecin.component';
import { RapportActiviterAutreComponent } from './rapport-activite/rapport-activiter-autre/rapport-activiter-autre.component';
import { RappertActiviterAutComponent } from './rapport-activite/rappert-activiter-aut/rappert-activiter-aut.component';
import { RappertActiviterRembComponent } from './rapport-activite/rappert-activiter-remb/rappert-activiter-remb.component';
import { RappertActiviterMedComponent } from './rapport-activite/rappert-activiter-med/rappert-activiter-med.component';
import {DayPilotModule} from "daypilot-pro-angular";
import { VideoDrMamyComponent, NgbdModalContent_mamy } from './modal/ajout-docteur-tsz/video-dr-mamy/video-dr-mamy.component';
import { VideoDrVioletyComponent, NgbdModalContent_vio } from './modal/ajout-docteur-tsz/video-dr-violety/video-dr-violety.component';
import { GanttComponent } from './statistique-global/gantt/gantt.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { DetailEnvironementComponent } from './bibliotheque-virtuelle/detail-environement/detail-environement.component';
import { DetailTextComponent } from './information/detail-text/detail-text.component';
import { ListeQuestionAgentComponent } from './questonaire/liste-question-agent/liste-question-agent.component';
import { IecEpidemieComponent } from './information/iec-epidemie/iec-epidemie.component'; // for FullCalendar!
import { NgxPaginationModule } from 'ngx-pagination';
import { LutteContreEpidemieComponent } from './infrastructure/lutte-contre-epidemie/lutte-contre-epidemie.component';
import { InfoVisiteurComponent } from './modal/ajout-docteur/info-visiteur/info-visiteur.component';
import { BcComponent } from './consulatation-medicale/bc/bc.component';
import { ValiditationBcComponent } from './consulatation-medicale/validitation-bc/validitation-bc.component';
import { DetailBcComponent } from './consulatation-medicale/detail-bc/detail-bc.component';
import { ValidBcPatientComponent } from './modal/ajout-docteur/valid-bc-patient/valid-bc-patient.component';
import { FormValidBcComponent } from './consulatation-medicale/form-valid-bc/form-valid-bc.component';
import { ImagevideocovidComponent } from './information/iec-epidemie/imagevideocovid/imagevideocovid.component';
import { GanttBcServiceComponent } from './consulatation-medicale/gantt-bc-service/gantt-bc-service.component';
import { DetailEpidemieComponent } from './information/iec-epidemie/detail-epidemie/detail-epidemie.component';
import { ArticleComponent } from './information/article/article.component';
import { Article2Component } from './information/article2/article2.component';
import { Article3Component } from './information/article3/article3.component';
//import { NgxImageGalleryModule } from 'ngx-image-gallery';
//import { SwiperModule } from 'ngx-swiper-wrapper';
//import {MatProgressBarModule} from '@angular/material/progress-bar';
//import {MatProgressSpinnerModule} from '@angular/material/progress-spinner'; 
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        //HttpClientModule,
        PopupModule.forRoot(),
        PdfViewerModule,
        DayPilotModule,
        FullCalendarModule,
        NgxPaginationModule,
        //NgxImageGalleryModule,
       // SwiperModule
      //  MatProgressBarModule,
       // MatProgressSpinnerModule 
      //  MatPaginatorModule,
      //  ChartsModule,

    ],
    declarations: [
        MedecinComponent, QuestonaireComponent, MesHistoriqueComponent,
        AjoutDocteurComponent,
        RemboursementComponent,
        AnalyseComponent,
        ConsulatationMedicaleComponent,
        IecComponent,
        TextComponent,
        ContactComponent,
        EvaluationEnligneComponent,
        MedecinAnsComponent,
        MedecinTszComponent,
        AjoutDocteurTszComponent,
        InfoAnalyseComponent,
        ProcedureConsultationComponent,
        AffichageConsultationComponent,
        StatistiqueConsultationComponent,
        StatistiqueRembourseComponent,
        InfoRembourseComponent,
        ProcedureRembourseComponent,
        DetailIecComponent,
        CalendrierMedecinComponent,
        RapportActiviteComponent,
        NosInfrastructureComponent,
       // NgbdModalComponent,
        NgbdModalContent,
        NgbdModalContent_I,
        NgbdModalContent_o,
        NgbdModalContent_v,
        NgbdModalContent_r,
        NgbdModalContent_no,
        NgbdModalContent_ro,
        NgbdModalContent_tia,
        NgbdModalContent_la,
        NgbdModalContent_laing,
        NgbdModalContent_fan,
        NgbdModalContent_niv,
        NgbdModalContent_kol,
        NgbdModalContent_ri_ma,
        NgbdModalContent_andr,
        NgbdModalContent_man,
        NgbdModalContent_ifan,
        NgbdModalContent_her,
        NgbdModalContent_thier,
        NgbdModalContent_har,
        NgbdModalContent_vio,
        NgbdModalContent_mamy,
        SatistiqueConsultationMedComponent,
        SatistiqueConsultationAgentComponent,
        StatistiqueRembourseAgentComponent,
        StatistiqueRembourseTraiteComponent,
        StatistiqueGlobalComponent,
        StatistiqueGlobalConsultationComponent,
        StatistiqueGlobalRemboursementComponent,
        StatistiqueGlobalReposMedicaleComponent,
        StatistiqueGlobalAgentEtFamilleComponent,
        BibliothequeVirtuelleComponent,
        StatistiqueReposAgentComponent,
        GestionMedicamentComponent,
        GestionMedicamentPharmacieComponent,
        GestionMedicamentEntrepotComponent,
        MedicamentConsommerParAgentComponent,
        MedicamentLivrerComponent,
        VideoDrOnjaComponent,
        VideoDrRinaComponent,
        VideoDrVonyComponent,
        VideoDrNorolalaComponent,
        VideoDrRolandComponent,
        VideoDrLaingoComponent,
        VideoDrFanjaComponent,
        VideoDrNivoComponent,
        VideoDrKoloinaComponent,
        VideoDrThieryComponent,
        VideoDrHeryComponent,
        VideoDrHaryComponent,
        VideoDrRijaMamyComponent,
        VideoDrManohyComponent,
        VideoDrAndryComponent,
        VideoDrIfanoComponent,
        ViewMedicamentLivrerComponent,
        LienUtileComponent,
        MedParPharmacieComponent,
        VideDrTianaComponent,
        VideDrLantoComponent,
        VoireQuestionComponent,
        RapportActiviterRembourseComponent,
        RapportActiviterMedecinComponent,
        RapportActiviterAutreComponent,
        RappertActiviterAutComponent,
        RappertActiviterRembComponent,
        RappertActiviterMedComponent,
        VideoDrMamyComponent,
        VideoDrVioletyComponent,
        GanttComponent,
        DetailEnvironementComponent,
        DetailTextComponent,
        ListeQuestionAgentComponent,
        IecEpidemieComponent,
        LutteContreEpidemieComponent,
        BcComponent,
        ValiditationBcComponent,
        DetailBcComponent,
        ValidBcPatientComponent,
        FormValidBcComponent,
        ImagevideocovidComponent,
        GanttBcServiceComponent,
        DetailEpidemieComponent,
        ArticleComponent,
        Article2Component,
        Article3Component,
        //InfoVisiteurComponent,
        // InfrastructureComponent,
        // ActualiterComponent
    ],
    entryComponents: [NgbdModalContent,NgbdModalContent_I,NgbdModalContent_o,
        NgbdModalContent_v,NgbdModalContent_r,NgbdModalContent_no,NgbdModalContent_ro,
        NgbdModalContent_tia,
        NgbdModalContent_la,
        NgbdModalContent_laing,
        NgbdModalContent_fan,
        NgbdModalContent_niv,
        NgbdModalContent_kol,
        NgbdModalContent_ri_ma,
        NgbdModalContent_andr,
        NgbdModalContent_man,
        NgbdModalContent_ifan,
        NgbdModalContent_her,
        NgbdModalContent_thier,
        NgbdModalContent_har,
        NgbdModalContent_vio,
        NgbdModalContent_mamy
       

    ] ,
    exports:  [ GanttComponent ],
})
export class PagesModule { }
